import React, { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { datePlusTime, formatDateForServer } from '@common/utils';
import { RecordActivityModal } from '@components/RecordActivityModal';

import { WellnessTypesEnum } from '../../../constants';
import { hideEditModal, saveLogItem, SaveWeightRequestType, weightRecordActivitySelector } from '../../../store';
import { WeightItemType } from '../../../types';
import { useResetEntryCount } from '../../../useReserEntryCount';
import { FormValuesType } from '../types';
import { WeightForm } from './WeightForm';

export function WeightRecordActivityModal() {
  const { editModalVisible, selectedItem, saveFormStatus } = useSelector(weightRecordActivitySelector);
  const dispatch = useDispatch();
  const [entryCount, setEntryCount] = useState(0);

  const handleSave = useCallback(
    (formValues: FormValuesType, recordAnotherEntry = false) => {
      const requestData: SaveWeightRequestType['data'] = {
        id: formValues.id,
        result: Number(formValues.result),
        recorded_at: formatDateForServer(datePlusTime(formValues.date, formValues.time)),
      };

      dispatch(saveLogItem({ data: requestData, type: WellnessTypesEnum.Weight, recordAnotherEntry, entryCount }));
      setEntryCount(entryCount + 1);
    },
    [dispatch, entryCount],
  );

  const handleClose = useCallback(() => {
    dispatch(hideEditModal({ type: WellnessTypesEnum.Weight }));
  }, [dispatch]);

  useResetEntryCount(editModalVisible, setEntryCount);

  return (
    <RecordActivityModal open={editModalVisible} onClose={handleClose}>
      <WeightForm
        onClose={handleClose}
        onSave={handleSave}
        initialValues={selectedItem as Nullable<WeightItemType>}
        saveFormStatus={saveFormStatus}
      />
    </RecordActivityModal>
  );
}
